import React from "react";
import { Controller } from "react-hook-form";

import { SettingsCard } from "../../../../../components/card/SettingsCard";
import { SettingsInput } from "../../../../../components/inputs/SettingsInput";
import { FieldLabel } from "../../../../../components/newUI/text";
import { Swiper } from "../../../../../components/swiper/Swiper";
import { TaskTemplateDetailsSectionProps } from "../model/taskTemplateEditor.types";

export const TaskTemplateDetailsSection: React.FC<
  TaskTemplateDetailsSectionProps
> = ({ control, isEditing, template, onActiveChange }) => (
  <SettingsCard extraClasses={"p-6 mb-4"}>
    <div className={"mb-4 text-xl font-semibold text-[#2B333C]"}>
      Template Details
    </div>

    <div className={"flex items-center gap-6"}>
      <div className={"w-1/4"}>
        <Controller
          control={control}
          rules={{
            required: "This field is required",
          }}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <>
              <FieldLabel label={"Title"} required />
              <SettingsInput
                value={value}
                isError={!!error}
                onChange={(event) => onChange(event.target.value)}
                placeholder={"Title..."}
                inputClasses={"w-full"}
              />
            </>
          )}
          name={"templateName"}
        />
      </div>

      <div className={"w-2/4"}>
        <Controller
          control={control}
          render={({ field: { value, onChange } }) => (
            <>
              <FieldLabel label={"Description (optional)"} />
              <SettingsInput
                value={value}
                onChange={(event) => onChange(event.target.value)}
                placeholder={"This template is used for..."}
                inputClasses={"w-full"}
              />
            </>
          )}
          name={"description"}
        />
      </div>

      <div className={"w-1/4"}>
        {isEditing && template && (
          <>
            <FieldLabel label={"Template Status"} />
            <Swiper
              value={template.isActive}
              onChange={onActiveChange}
              description={template.isActive ? "Active" : "Inactive"}
              descriptionPosition={"right"}
            />
          </>
        )}
      </div>
    </div>
  </SettingsCard>
);
